import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faInfoCircle, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'

import React, { Fragment as F, useContext, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import {
  useNavigate,
} from 'react-router'
import {
  Link,
  useParams,
} from "react-router-dom"
import { toast } from 'react-toastify'

import {
  appRouter,
  C,
  defaultBanksQueryTmpl,
  logg,
  useApiRouter,
} from '$shared'

import {
  AppCtx,
} from '$src/App'
import {
  BanksCtx,
} from '$src/components/banks'
import {
  defaultSavedQuery,
  QueriesCtx,
} from '$src/components/queries'
import {
  ReportsCtx,
} from '$src/components/reports'

library.add( faFilter, faInfoCircle, faSearch, faTimes )

/*
 * RenameModal
**/
const RenameModal = (props) => {
  // logg(props, 'RenameModal')

  /* ctx */

  const apiRouter = useApiRouter()
  const navigate  = useNavigate()

  const {
    actionName, setActionName,
    loading,    setLoading,
    renameModalOpen, setRenameModalOpen,
    selectedResource, setSelectedResource,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in RenameModal')

  const {
    query,         setQuery,
    results,       setResults,
    selectedBanks, setSelectedBanks,
  } = useContext(BanksCtx)

  const {
    savedQuery,     setSavedQuery,
    queryModalOpen, setQueryModalOpen,
    queriesList,      setQueriesList,      refreshQueriesList,
    queriesModalOpen, setQueriesModalOpen,
  } = useContext(QueriesCtx)

  const {
    refreshAdvancedReportsList,
    refreshReportsList,
  } = useContext(ReportsCtx)

  /* state */

  /* effects */

  const [ modalTitle, setModalTitle ] = useState('Rename')
  useEffect(() => {
    // if (!actionName) { return }
    if (!selectedResource.kind) { return }
    switch (selectedResource.kind) {
      case C.kinds.AdvancedReport:
      case C.kinds.AdvancedReport_financials:
      case C.kinds.AdvancedReport_fintegration:
        setModalTitle('Rename Multi FI Report')
        break
      case C.kinds.Report:
        setModalTitle('Rename Single FI Report')
        break
      case C.kinds.Query:
        setModalTitle('Rename Query')
        break
      case C.kinds.List:
        setModalTitle('Rename List')
        break
      default:
        throw 't54 - This should not happen'
    }
  }, [ selectedResource.kind, renameModalOpen ])

  /* methods */

  const handleSave = () => {
    setLoading(true)
    let promise

    switch (selectedResource.kind) {
      case C.kinds.AdvancedReport:
      case C.kinds.AdvancedReport_financials:
        promise = fetch(apiRouter.advancedReportPath({ id: selectedResource.id }), {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            report: {
              name: selectedResource.name,
            }
          }),
        }).then(r => r.json()).then(() => {
          refreshAdvancedReportsList()
        })
        break

      case C.kinds.Report:
        promise = fetch(apiRouter.reportRenamePath({ id: selectedResource.id }), {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            report: {
              name: selectedResource.name,
            }
          }),
        }).then(r => r.json()).then(() => {
          refreshReportsList()
        })
        break

      case C.kinds.List:
      case C.kinds.Query:
        promise = fetch(apiRouter.queryRenamePath({ id: selectedResource.id }), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query: {
              name: selectedResource.name,
            }
          }),
        }).then(r => r.json()).then(() => {
          refreshQueriesList()
        })
        break

      default:
        throw '361 - this should never happen.'
    }
    promise.then(() => {
      toast(`Renamed the resource.`)
      setRenameModalOpen(false)
      setResults([])

      navigate('/')
      setSelectedBanks({})
      setSavedQuery(defaultSavedQuery)
      setQuery(defaultBanksQueryTmpl)

    }).catch((err) => {
      logg(err, 'could not rename resource')
      toast('Could not rename the resource')
    }).finally(() => {
      setLoading(false)
    })
  }

  return <Modal
    ariaHideApp={false}
    className="ListModal BaseModal"
    isOpen={renameModalOpen}
    onRequestClose={ () => setRenameModalOpen(false) }
    overlayClassName="ModalOverlay-z10"
  >
    <div className='header'>
      <h5 >{ modalTitle }</h5>
      <div className='right'>
        <Link to='/' style={{ color: '#666' }} ><div className='close' style={{ width: '30px' }} onClick={() => {
          setRenameModalOpen(false) ;
        } }><FontAwesomeIcon icon="fa-solid fa-times"
          style={{ cursor: 'pointer' }}
        /></div></Link>
      </div>
    </div>

    <div className='container'>
      <div className='row mt-3'>
        <div className='col-md-2'></div>
        <div className='col-md-8'>
          <div className='field'>
            <label>Name</label>&nbsp;
            <input type='text' value={selectedResource.name} onChange={(ev) => setSelectedResource({ ...selectedResource, name: ev.target.value }) } />
          </div>
        </div>
      </div>
      { /* actionName === C.queries_actions.rename ? null : <div className='field-checkbox'>
        <input type='checkbox' checked={savedQuery.is_merge} onChange={(ev) => setSavedQuery({ ...savedQuery, is_merge: ev.target.checked }) } />
        <label>Merged</label>
      </div> */ }
    </div>

    <div className='actions'>
      <div className='left'></div>
      <div className='right'>
        <div className='Btn btn-primary' onClick={handleSave} >Save</div>
      </div>
    </div>

  </Modal>

}
export default RenameModal
